import React, {
  useMemo,
  useContext,
  useState,
} from 'react'
import {
  Box,
  IcoMoon,
  ResponsiveContext,
  Text,
  RemoveIcon,
  AddIcon,
} from '@usap/uicomponents'
import { Heading3 } from '../common/heading'

export default function VehicleSpecifications({ vehicleSpecifications }) {
  const responsiveContext = useContext(ResponsiveContext)
  let screenSize
  if (responsiveContext.toLowerCase().includes('mobile')) {
    screenSize = 'small'
  }
  if (responsiveContext.toLowerCase().includes('tablet')) {
    screenSize = 'medium'
  }
  if (responsiveContext.toLowerCase().includes('desktop')) {
    screenSize = 'large'
  }
  const [isDisplay, setIsDisplay] = useState(true)

  const titleCell = useMemo(() => ({
    padding: 10,
    minWidth: 100,
    backgroundColor: '#F5F5F5',
    border: '1px solid #E0E0E0',
    justifyContent: 'center',
  }), [])

  const bodyCell = useMemo(() => ({
    padding: 10,
    minWidth: 150,
    border: '1px solid #E0E0E0',
    justifyContent: 'center',
  }), [])

  const mainTable = useMemo(() => ({
    justifyContent: 'space-evenly',
    marginTop: '26px',
    overflow: 'auto',
  }), [])

  const handleAccordion = () => {
    if (isDisplay) {
      setIsDisplay(false)
    } else {
      setIsDisplay(true)
    }
  }

  const getColSpan = (header, index) => {
    const { vehicleSpan } = vehicleSpecifications
    if (header.key && header.subKey) {
      const getIndex = vehicleSpan
        .findIndex(element => element.index === index && element.sub === header.subKey)
      if (getIndex < 0) return 0
      return vehicleSpan[getIndex].iteration
    }
    const getIndex = vehicleSpan
      .findIndex(element => element.index === index && element.main === header.key)
    if (getIndex < 0) return 0
    return vehicleSpan[getIndex].iteration
  }

  const displayData = () => vehicleSpecifications.headerData.filter(headerFilter => {
    let foundData = false
    vehicleSpecifications.data.forEach(result => {
      if (headerFilter.subKey && !foundData) {
        foundData = Boolean(result[headerFilter.key][headerFilter.subKey])
      }
      if (!headerFilter.subKey && !foundData) {
        foundData = Boolean(result[headerFilter.key])
      }
    })
    return foundData
  }).map(header => (
    <tr key={header.title} direction="row">
      <td style={titleCell}>
        <Text size="xsmall" color="dark-1" weight="bold">
          { header.title }
        </Text>
      </td>
      {
        vehicleSpecifications.data.map((result, index) => {
          const colSpanValue = getColSpan(header, index)
          let displayTd = true
          if (header.subKey) {
            if (!result[header.key][header.subKey]) {
              displayTd = false
            }
          } else if (!result[header.key]) {
            displayTd = false
          }
          const colSpanStyle = { textAlign: 'center' }
          if (displayTd) {
            return (
              <td colSpan={colSpanValue} key={`${Math.random()}`} style={header.key === 'submodel' ? { ...titleCell, ...colSpanStyle } : { ...bodyCell, ...colSpanStyle }}>
                {
                  // With SubKey
                  header.subKey && result[header.key][header.subKey] && (
                    <Text size="xsmall" color="dark-1">
                      { result[header.key][header.subKey] }
                    </Text>
                  )
                }
                {
                  // Without SubKey
                  !header.subKey && result[header.key] && (
                    <Text size="xsmall" color="dark-1">
                      { result[header.key] }
                    </Text>
                  )
                }
              </td>
            )
          }
          return null
        })
      }
    </tr>
  ))

  return (
    <Box
      id="categories"
      width="1248px"
      margin={{ vertical: screenSize === 'large' ? 'medium' : '0px', horizontal: 'auto' }}
      pad={
        screenSize === 'large'
          ? { left: 'small', bottom: '6px' }
          : {
            vertical: '12px',
            horizontal: '12px',
          }
      }
    >
      <Box style={{
        flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
      }}
      >
        <Heading3
          size={screenSize === 'large' ? 'medium' : 'small'}
          title="Vehicle Specifications"
        />
        <Box style={{ cursor: 'pointer' }} onClick={handleAccordion}>
          <IcoMoon icon={isDisplay ? RemoveIcon : AddIcon} color="#393939" />
        </Box>
      </Box>
      {
        isDisplay && (
          <Box style={mainTable}>
            <table border="0" cellPadding="4" cellSpacing="0">
              { displayData() }
            </table>
          </Box>
        )
      }
    </Box>
  )
}
